import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.701}
    height={23.407}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 350319 319053"
    {...props}
  >
    <path
      d="M1381 16315c0-3091 2509-15748 5610-15748L341082 0c3091 0 7861 13224 7861 16315 0 3107 3091 0 0 0H1381c-3097 0 0 3107 0 0zm11210 28031h325137v11215c0 89639-72927 162566-162566 162566-89644 0-162571-72927-162571-162566V44346zm207416 213042c0 9273-7547 16815-16820 16815h-56055c-9273 0-16815-7542-16815-16815v-33914c28617 7645 61073 7645 89690 0v33914zm-100906-37324v37324c0 15450 12576 28030 28031 28030v28030c0 3096 2509 5605 5605 5605s5605-2509 5605-5605l5-28030h33630v28030c0 3096 2514 5605 5605 5605 3096 0 5605-2509 5605-5605v-28030c15460 0 28035-12580 28035-28030v-37324c68399-23368 117721-88284 117721-164503V38741c0-3091-2519-5605-5610-5605H6991c-3101 0-5610 2514-5610 5605v16820c0 76219 49322 141135 117720 164503z"
      style={{
        fill: "#1c1c1d",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
